(function($) {
$(document).ready(function() {

var $$ = {};
$$.pattern = $('#pattern');
$$.insensitive = $('#insensitive');
$$.test = $('#test');
$$.matches = $('#matches');
$$.fields = $()
	.add($$.pattern)
	.add($$.insensitive)
	.add($$.test);

var params = {};
params.pattern = 'bana(na)+';
params.insensitive = true;
params.test = 'Can you spell banananananana?';

// Update parameters
function update() {
	params.pattern = $$.pattern.val();
	params.insensitive = $$.insensitive.prop('checked');
	params.test = $$.test.val();
}

// Save form data to storage
function save() {
	if (window.localStorage) {
		update();
		localStorage.setItem('regexper', JSON.stringify(params));
	}
}

// Load form data from storage
function load() {
	if (window.localStorage) {
		var loaded = localStorage.getItem('regexper');
		if (loaded !== null) {
			params = JSON.parse(loaded);
		}
		$$.pattern.val(params.pattern);
		$$.insensitive[0].checked = params.insensitive;
		$$.test.val(params.test);
	}
}

// Run expression tester
function run() {
	var exp, test = params.test;
	try  {
		exp = new RegExp(
			params.pattern,
			(params.insensitive ? 'gi' : 'g')
		);
		$$.pattern
			.removeClass('invalid')
			[0].title = '';
	} catch(error) {
		$$.pattern
			.addClass('invalid')
			[0].title = error.message;
	}

	// Find matches in string
	if (params.pattern !== '' && params.test !== '') {
		test = params.test.replace(exp, function($0) {
			return '<span class="match">' + $0 + '</span>';
		});
	}
	$$.matches.html(test.replace(/\n/gi, '<br />'));
}

// Run and save on change
$$.fields
.on('keyup change', function() {
	if ($$.pattern.val().match(/^\s+$/gi) === null && $$.test.val().match(/^\s+$/gi) === null) {
		update();
		save();
		run();
	}
})
.on('keydown', function(event) {
	switch (event.which) {
		case 9:
			var active = document.activeElement;
			switch (active) {
				case $$.pattern[0]:
					$$.test.focus();
					break;
				case $$.test[0]:
					$$.pattern.focus();
					break;
			}
			return false;
		case 27:
			$(this).val('');
	}
});

load();
run();

$$.pattern.select();

});
}(jQuery));
